module.exports = __webpack_public_path__ + "img/alpay.76841353.png";